import styled from 'styled-components';
import ProductCardKit from '../card/ProductCardKit';

export default function CommonSpartPartSelecction({ product }) {

    if (!product) {
        return <h3 style={{textAlign: 'center', margin: '2rem 0rem'}}> Seleccione una Marca y un Producto para ver sus Kit</h3>;
    }

    const { producto } = product;

    return (
        <StyledCommonSpartPartSelection>
            <div className="containerSpartParts">
                <ProductCardKit product={producto} type="kit" />
            </div>
        </StyledCommonSpartPartSelection>
    );
}

const StyledCommonSpartPartSelection = styled.div`
    .containerSpartParts{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 2rem 0rem;
        @media (min-width: 992px){
            padding: 0rem 0rem 0rem 3rem;
        }
    }
`
